import colors, { appTheme } from '@/config/colors';
import { StyleSheet } from 'react-native';
import { isPatientApp } from '@/config/constants';

const styles = StyleSheet.create({
  common: {
    borderRadius: 8,
    padding: 16,
    height: 52,
    flexDirection: 'row',
    alignItems: 'center',
  },
  commonLabel: {
    overflow: 'visible',
    fontFamily: 'InterSemiBold',
    includeFontPadding: false,
    fontSize: 16,
    lineHeight: 18,
  },

  primary: {
    color: colors.white,
    backgroundColor: appTheme.primary,
  },
  primaryPressed: {
    backgroundColor: isPatientApp
      ? colors.newUI.therapist.green30
      : colors.newUI.therapist.primaryBlue50,
  },
  primaryHovered: {
    backgroundColor: appTheme.medium,
  },
  primaryDisabled: {
    backgroundColor: colors.newUI.therapist.grey50,
    color: colors.white,
  },
  primaryLabel: {
    color: colors.white,
  },
  primaryLabelDisabled: {
    backgroundColor: colors.newUI.therapist.grey50,
    color: colors.white,
  },
  primaryLabelHovered: {},
  primaryLabelPressed: {},

  secondary: {
    color: appTheme.primary,
    backgroundColor: colors.white,
    borderColor: appTheme.primary,
    borderWidth: 1,
    borderStyle: 'solid',
  },
  secondaryPressed: {
    backgroundColor: appTheme.light,
  },
  secondaryHovered: {
    borderColor: appTheme.medium,
  },
  secondaryDisabled: {
    borderColor: colors.newUI.therapist.grey50,
    color: colors.newUI.therapist.grey50,
    backgroundColor: colors.white,
    borderWidth: 1,
    borderStyle: 'solid',
  },
  secondaryLabel: {
    color: appTheme.primary,
  },
  secondaryLabelDisabled: {
    color: colors.newUI.therapist.grey50,
  },
  secondaryLabelHovered: {
    color: appTheme.medium,
  },
  secondaryLabelPressed: {
    color: appTheme.medium,
  },

  tertiary: {
    color: appTheme.primary,
    backgroundColor: 'transparent',
  },
  tertiaryPressed: {
    backgroundColor: appTheme.light,
    color: appTheme.primary,
  },
  tertiaryHovered: {
    backgroundColor: appTheme.light,
  },
  tertiaryDisabled: {
    color: colors.newUI.therapist.grey50,
  },
  tertiaryLabel: {
    color: appTheme.primary,
  },
  tertiaryLabelDisabled: {
    color: colors.newUI.therapist.grey50,
  },
  tertiaryLabelHovered: {
    color: appTheme.medium,
  },
  tertiaryLabelPressed: {
    color: appTheme.primary,
  },

  warning: {
    backgroundColor: colors.newUI.therapist.orange90,
  },
  warningPressed: { backgroundColor: colors.newUI.therapist.orange40 },
  warningHovered: {},
  warningDisabled: {},
  warningLabel: { color: colors.white },
  warningLabelDisabled: {},
  warningLabelHovered: {},
  warningLabelPressed: {},

  warningTertiary: {},
  warningTertiaryPressed: { backgroundColor: colors.newUI.therapist.orange40 },
  warningTertiaryHovered: {},
  warningTertiaryDisabled: {},
  warningTertiaryLabel: { color: colors.newUI.therapist.orange90 },
  warningTertiaryLabelDisabled: {},
  warningTertiaryLabelHovered: {},
  warningTertiaryLabelPressed: {},

  danger: {
    color: colors.white,
    backgroundColor: colors.newUI.therapist.red70,
  },
  dangerPressed: {
    backgroundColor: colors.newUI.therapist.red30,
  },
  dangerHovered: {
    backgroundColor: colors.newUI.therapist.red50,
  },
  dangerDisabled: {
    backgroundColor: colors.newUI.therapist.red30,
  },
  dangerLabel: {
    color: colors.white,
  },
  dangerLabelDisabled: {
    color: colors.white,
  },
  dangerLabelHovered: {},
  dangerLabelPressed: {},

  ghost: {
    color: appTheme.primary,
    backgroundColor: isPatientApp
      ? colors.white
      : colors.newUI.therapist.grey20,
  },
  ghostPressed: {
    backgroundColor: appTheme.light,
  },
  ghostHovered: {
    backgroundColor: appTheme.light,
  },
  ghostDisabled: {
    backgroundColor: colors.newUI.therapist.grey20,
    color: colors.newUI.therapist.grey50,
  },
  ghostLabel: {
    color: appTheme.primary,
  },
  ghostLabelDisabled: {
    color: colors.newUI.therapist.grey50,
  },
  ghostLabelHovered: {
    color: appTheme.medium,
  },
  ghostLabelPressed: {
    color: appTheme.primary,
  },
});

export default styles;
